import Dialog from '@mui/material/Dialog'

import { Icon } from '../../../../components/UI'
import TutorDetailsUser from './TutorDetailsUser'
import TutorDetailsRate from './TutorDetailsRate'
import TutorDetailsClasses from './TutorDetailsClasses'
import TutorDetailsReviews from './TutorDetailsReviews'

const TutorDetails = ({ open, classBanner, onClose }) => {
  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[800px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      <div className="w-full flex items-center justify-center flex-col">
        <button className="flex items-center mr-auto" onClick={handleClose}>
          <Icon name="arrow-left-line" color="#F67443" className="w-[24px] h-[24px]" />

          <span className="ml-[12px] text-sm font-normal text-primary-100">Back</span>
        </button>

        <TutorDetailsUser classBanner={classBanner} />

        <div className="w-full flex mt-[10px] gap-x-[10px]">
          <TutorDetailsRate classBanner={classBanner} />
          <TutorDetailsClasses classBanner={classBanner} />
        </div>

        <TutorDetailsReviews classBanner={classBanner} />
      </div>
    </Dialog>
  )
}

export default TutorDetails
